import React from 'react';
import { Card } from 'antd';
import text from '../../../constants/EnterprisePromotionTranslation.json';

const EnterprisePromotion: React.FC = () => {
  return <Card className="h-full w-full">{text.message}</Card>;
};

export default EnterprisePromotion;
